<template>
  <div style='padding: 20px 0;'>
    <section class='inquiry-detail-header'>
      <div class='inquiry-title-main'>
        <div class='inquiry-title-tools'>
          <el-button class='inquiry-back-link' type='text' icon='el-icon-arrow-left' @click='$router.back()'>返回列表</el-button>
          <span class='inquiry-kicker'>询单详情</span>
        </div>
        <h1>{{ baseInfo.name || '' }}</h1>
        <p>{{ baseInfo.type_alias || '' }} · {{ baseInfo.status_alias || '' }} · {{ baseInfo.is_apply_alias || '' }}</p>
      </div>
      <div class='inquiry-header-side'>
        <div class='inquiry-status-card'>
          <span>项目状态</span>
          <strong>{{ baseInfo.status_alias || '—' }}</strong>
        </div>
        <div class='inquiry-status-card'>
          <span>报名状态</span>
          <strong>{{ baseInfo.is_apply_alias || '—' }}</strong>
        </div>
      </div>
    </section>
    <el-tabs v-model='activeName'>
      <el-tab-pane label='询单信息' name='info'>
        <infoCard @infoPlatform='infoPlatform'></infoCard>
      </el-tab-pane>
      <el-tab-pane label='报名表' name='signUp'>
        <div v-if="activeName==='signUp'" class='default-table'>
          <!--      报名表-->
          <registration-table :tab-platforms='tabPlatforms' :project-id='projectId' :dimension-id='1'
                              v-if='projectId&&tabPlatforms&&tabPlatforms.length>0'></registration-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label='初选表' name='selection'>
        <!--      初选表-->
        <div v-if="activeName==='selection'" class='default-table'>

          <registration-table :tab-platforms='tabPlatforms' :project-id='projectId' :dimension-id='2'
                              v-if='projectId&&tabPlatforms&&tabPlatforms.length>0'></registration-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label='合作表' name='cooperate'>
        <!--      合作表-->
        <div v-if="activeName==='cooperate'" class='default-table'>
          <registration-table :tab-platforms='tabPlatforms' :project-id='projectId' :dimension-id='3'
                              v-if='projectId&&tabPlatforms&&tabPlatforms.length>0'></registration-table>
        </div>
      </el-tab-pane>
      <br>
    </el-tabs>

    <!--      日志 -->
    <ProjectLog :project-id='projectId' v-if="userPermissions.indexOf('inquiry_project_log') !== -1" />

    <br>
    <br>

  </div>
</template>

<script>
import infoCard from './components/infoCard'
import { mapGetters } from 'vuex'
import RegistrationTable from '@/pages/inquiries/components/RegistrationTable.vue'
import ProjectLog from '@/pages/inquiries/components/ProjectLog.vue'

export default {
  name: 'InfoDetail',
  components: {
    ProjectLog,
    RegistrationTable,
    infoCard
  },
  data() {
    return {
      projectId: '',
      loadingStatus: false,
      infoPlatforms: [],
      tabPlatforms: [],
      baseInfo: { name: '', type: '', status: '', is_apply: 0, type_alias: '', status_alias: '', is_apply_alias: '' },
      activeName: 'info',
      logShow: false
    }
  },
  computed: {
    ...mapGetters(['userPermissions'])
  },
  methods: {
    infoPlatform(val) {
      this.infoPlatforms = val
      if (val?.length > 0) {
        this.tabPlatforms = val.map((item) => {
          return item
        })
      }
    },
    getInfo() {
      this.$api.getBaseInquiryProject(this.projectId).then((resp) => {
        // console.log(resp)
        this.baseInfo = resp.info || {}
      })
    }
  },
  mounted() {
    this.projectId = this.$route.params.id
    sessionStorage.setItem('isTab', 'null')
    this.getInfo()

  }
}
</script>
<style scoped>
.el-steps >>> .el-step {
  cursor: pointer !important;
}
</style>
<style lang='scss'>
.newForm {
  /*border: 1px solid red;*/
  .el-form-item__label {
    color: black;
    font-weight: 600;
  }

  .el-form-item--mini.el-form-item {
    margin-bottom: 13px;
  }
}

.title {
  font-size: 18px;
  font-weight: 800;
}

.download {
  color: #ff3176;
  margin-left: 10px;
  cursor: pointer;
}

.row {
  > h3 {
    display: flex;
    float: left;
    margin-right: 80px;
    text-align: center;
  }
}

.inquiry-detail-header {
  min-height: 104px;
  padding: 18px 22px;
  margin-bottom: 12px;
  background: #ffffff;
  border: 1px solid #e7ebf2;
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.inquiry-back-link {
  height: 24px;
  padding: 0;
  color: #667085;
  font-size: 13px;
  line-height: 24px;
}

.inquiry-title-main {
  min-width: 0;
}

.inquiry-title-tools {
  display: flex;
  align-items: center;
  gap: 12px;
}

.inquiry-kicker {
  height: 24px;
  padding: 0 10px;
  color: #ff3176;
  background: #fff0f6;
  border: 1px solid #ffd1e2;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  line-height: 24px;
}

.inquiry-title-main h1 {
  margin: 8px 0 4px;
  color: #172033;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0;
}

.inquiry-title-main p {
  margin: 0;
  color: #7a8494;
  font-size: 13px;
  line-height: 20px;
}

.inquiry-header-side {
  display: flex;
  align-items: stretch;
  gap: 12px;
  flex: 0 0 auto;
}

.inquiry-status-card {
  min-width: 150px;
  padding: 12px 14px;
  background: #f8fafc;
  border: 1px solid #edf1f6;
  border-radius: 8px;
  box-sizing: border-box;
}

.inquiry-status-card span {
  color: #8a94a6;
  display: block;
  font-size: 12px;
  line-height: 18px;
}

.inquiry-status-card strong {
  margin-top: 4px;
  color: #263142;
  display: block;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
}

</style>
<style lang='scss' scoped>

.text {
  font-size: 20px;
  background: -webkit-linear-gradient(-90deg, #e97ca1 30%, #ff3176);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}


.isAssign {
  font-size: 40px;
  display: inline-block;
  transform: rotate(45deg);
  z-index: 99;
  position: absolute;
  right: 0;
  top: 30px;
  background-color: #ffeaf1;
  background-size: 120%;
  color: #ff3176;
}

.text2 {
  /*width: 100px;*/
  height: 40px;
  border-radius: 4px;
  text-align: center;
  /*font-size: 30px;*/
  color: white;
  background: #ff3176;
  /*background-color:#e97ca1 ;*/
  font-size: 14px;
  line-height: 40px;
  cursor: pointer;
  margin-bottom: 10px;
  transition-delay: 1s;
  float: left;
  margin-right: 10px;
  padding: 0 10px;

}

.text2:hover {
  background-image: linear-gradient(to left, #ebb5c7, #ff3176); /*-webkit-text-fill-color: transparent;*/
}
</style>
